import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ImporterRegistration, ImporterService } from '../importer.service';
import { EnvironmentService } from '../../services/environment.service';
import { LocalizationService } from '../../services/localization.service';
import { AuthService } from '../../services/auth.service';
import { WSImport } from '../import.models';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-pg-import',
    templateUrl: './pg-import.component.html',
    styleUrls: ['./pg-import.component.scss'],
    standalone: false
})
export class PgImportComponent implements OnInit {

    APIUrlOptions:Array<{ value: string, text: string, realms?: Array<string|number> }> = null;
    resourceOptions:Array<{ value: string, text: string }> = null;

    APIUrl:string = null;

    get allowedRealms():Array<string|number> {
        if(this.APIUrl != null && this.APIUrlOptions != null) {
            for(let _option of this.APIUrlOptions) {
                if(_option.value == this.APIUrl) {
                    if(_option.realms != null && _option.realms.length > 0) {
                        return _option.realms;
                    }
                    break;
                }
            }
        }
        return null;
    }
    
    resourceId:string = null;
    
    elementList:Array<string> = [];
    resourceElementList:Array<{ resource: string, id: string, municipality?: string, page?: number }> = [];

    isLoading = false;

    checkResult:WSImport.CheckResult = null;
    checkImportedKeys:{ [key:string]: boolean } = {};
    isCheckingImported = false;
    private _checkImportedSubscription:Subscription = null;
    private _checkImportedTimeout:any = null;

    constructor(private environmentService:EnvironmentService, private importerService:ImporterService, private localizationService:LocalizationService, private authService:AuthService, private route:ActivatedRoute, private router:Router) { }

    importerJobs:Array<WSImport.Job> = null;

    importerRegistration:ImporterRegistration = null;
    importerJobsCurrent:Array<WSImport.Job> = null;

    editJob:Partial<WSImport.Job> = {};

    importType:WSImport.JobType = 'entourance'
    importTypeList:Array<WSImport.JobType> = ['entourance','file','wordpress','dhm','eppoi']

    ngOnInit() {
        this.APIUrlOptions = [];

        let _realmImportAPI = this.authService.user.realm.configuration.importAPI;

        if(_realmImportAPI != null) {
            for(let _cAPI of _realmImportAPI) {
                if(_cAPI.url) {
                    this.APIUrlOptions.push({
                        value: _cAPI.url,
                        text: _cAPI.name,
                        realms: _cAPI.realms
                    })
                }
            }
        }

        this.resourceOptions = [];

        if(this.environmentService.environment.ImportResources != null) {
            for(let _cResource of this.environmentService.environment.ImportResources) {
                this.resourceOptions.push({ value: _cResource, text: this.localizationService.translateResource(_cResource) })
            }
        }

        this.importerRegistration = this.importerService.register();

        let _lastCurrentJob = null;

        this.importerRegistration.jobs.subscribe((data) => {
            if(data == null) {
                this.importerJobsCurrent = null;
                _lastCurrentJob = null;
            }
            else if(data instanceof Array) {
                this.importerJobsCurrent = data;

                if(this.importerJobsCurrent != null) {
                    let _checkLastCurrentJob = this.importerJobsCurrent[0]?.time;

                    this.importerJobsCurrent.reverse();

                    if(_lastCurrentJob == null) _lastCurrentJob = _checkLastCurrentJob
                    else if(_checkLastCurrentJob != _lastCurrentJob) {
                        _lastCurrentJob = _checkLastCurrentJob;
                        this.resetFinishedJobs()
                    }

                    this.refreshImporterJobs()
                }
            }
        })

        this.editJobRefresh()

        this.route.fragment.subscribe((fragment) => {
            let _type:WSImport.JobType = null;

            for(let _item of this.importTypeList) {
                if(fragment == _item && this.hasImportType(_item)) _type = _item;
            }

            if(_type == null) {
                for(let _item of this.importTypeList) {
                    if(this.hasImportType(_item)) {
                        _type = _item;
                        break;
                    }
                }
            }

            if(_type != null) this.setImportType(_type)
        })
    }

    refreshImporterJobs() {
        if(this.importerJobsCurrent == null) {
            this.importerJobs = null;
        }
        else {
            this.importerJobs = this.importerJobsCurrent.concat(this.importerJobsFinished)
        }
    }

    importerJobsFinished:Array<WSImport.Job> = [];
    importerJobsFinishedPageSize = 3;
    importerJobsFinishedPageNum = -1;
    isImporterJobsFinishedAtEnd = false;

    isImporterJobsFinishedLoading = false;

    resetFinishedJobs() {
        this.importerJobsFinished = []
        this.importerJobsFinishedPageSize = 3;
        this.importerJobsFinishedPageNum = -1;
        this.isImporterJobsFinishedAtEnd = false;

        this.loadMoreFinishedJobs()
    }

    loadMoreFinishedJobs() {
        if(!this.isImporterJobsFinishedAtEnd && !this.isImporterJobsFinishedLoading) {
            this.importerJobsFinishedPageNum ++
            this.isImporterJobsFinishedLoading = true;
            this.importerService.listFinishedJobs(this.authService.user.realm.id, this.importerJobsFinishedPageSize + 1, this.importerJobsFinishedPageNum * this.importerJobsFinishedPageSize).subscribe((data) => {
                for(let i = 0; i < this.importerJobsFinishedPageSize; i++) {
                    if(data[i] != null) {
                        this.importerJobsFinished.push(data[i])
                    }
                }
                this.isImporterJobsFinishedLoading = false;
                this.isImporterJobsFinishedAtEnd = data.length <= this.importerJobsFinishedPageSize
    
                this.refreshImporterJobs()
            })
        }
    }

    ngOnDestroy() {
        this._clearCheckImported();
        if(this.importerRegistration != null) this.importerRegistration.destroy()
    }

    goToImportType(type:WSImport.JobType) {
        this.router.navigate(['.'], { relativeTo: this.route, fragment: type })
    }

    setImportType(type:WSImport.JobType) {
        this.importType = type;

        this.editJob = {
            type: this.importType
        } 

        this.APIUrl = null;
        this.resourceId = null;
        this.elementList = [];
        this.resourceElementList = [];
        this.importFile = null;
        this._clearCheckImported();

        this.editJobRefresh()
    }

    onResourceElementListChange() {
        this.editJobRefresh();
        this._scheduleCheckImported();
    }

    onElementListChange() {
        this.editJobRefresh();
        this._scheduleCheckImported();
    }

    private _clearCheckImported() {
        if(this._checkImportedTimeout != null) {
            clearTimeout(this._checkImportedTimeout);
            this._checkImportedTimeout = null;
        }

        if(this._checkImportedSubscription != null) {
            this._checkImportedSubscription.unsubscribe();
            this._checkImportedSubscription = null;
        }

        this.checkResult = null;
        this.checkImportedKeys = {};
        this.isCheckingImported = false;
        this.updateAlreadyImported = false;
        this.updateSecondariesToo = false;
    }

    private _scheduleCheckImported() {
        if(this._checkImportedTimeout != null) {
            clearTimeout(this._checkImportedTimeout);
        }

        if(this._checkImportedSubscription != null) {
            this._checkImportedSubscription.unsubscribe();
            this._checkImportedSubscription = null;
        }

        this.isCheckingImported = true;

        this._checkImportedTimeout = setTimeout(() => {
            this._checkImportedTimeout = null;
            this._refreshCheckImported();
        }, 250);
    }

    private _getCheckObservable():Observable<WSImport.CheckResult> {
        let _realm = this.authService.user.realm?.id;

        if(this.importType == 'dhm') {
            if(this.resourceElementList == null || this.resourceElementList.length == 0) return null;

            return this.importerService.checkDHM(this.resourceElementList.map((_element) => ({
                resource: _element.resource,
                id: _element.id
            })), _realm)
        }
        else if(this.importType == 'eppoi') {
            if(this.resourceElementList == null || this.resourceElementList.length == 0) return null;

            return this.importerService.checkEPPOI(this.resourceElementList.map((_element) => {
                let _item:WSImport.JobEPPOIItem = {
                    resource: _element.resource,
                    id: _element.id
                }
                if(_element.municipality != null) _item.municipality = _element.municipality
                if(_element.page != null) _item.page = _element.page
                return _item
            }), _realm)
        }
        else if(this.importType == 'entourance') {
            if(this.APIUrl == null || this.resourceId == null || this.elementList == null || this.elementList.length == 0) return null;

            return this.importerService.checkEntourance(this.APIUrl, this.elementList.map((_id) => ({
                resource: this.resourceId,
                id: _id
            })), _realm)
        }
        else if(this.importType == 'wordpress') {
            if(this.APIUrl == null || this.resourceId == null || this.elementList == null || this.elementList.length == 0) return null;

            return this.importerService.checkWordPress(this.APIUrl, this.elementList.map((_id) => ({
                resource: this.resourceId,
                id: _id
            })), _realm)
        }

        return null;
    }

    private _refreshCheckImported() {
        let _observable = this._getCheckObservable();

        if(_observable == null) {
            this.checkResult = null;
            this.checkImportedKeys = {};
            this.isCheckingImported = false;
            this.updateAlreadyImported = false;
            this.updateSecondariesToo = false;
            return;
        }

        this._checkImportedSubscription = _observable.subscribe((result) => {
            this._checkImportedSubscription = null;
            this.isCheckingImported = false;
            this.checkResult = result;

            let _keys:{ [key:string]: boolean } = {};

            if(result?.imported != null) {
                for(let _entry of result.imported) {
                    if(_entry?.item?.resource != null && _entry?.item?.id != null) {
                        _keys[_entry.item.resource + '|' + _entry.item.id] = true;
                    }
                }
            }

            this.checkImportedKeys = _keys;

            if(!this.isCheckIncomplete() && this.getCheckImportedCount() == 0) {
                this.updateAlreadyImported = false;
                this.updateSecondariesToo = false;
            }
        }, () => {
            this._checkImportedSubscription = null;
            this.isCheckingImported = false;
            this.checkResult = null;
            this.checkImportedKeys = {};
            this.updateAlreadyImported = false;
            this.updateSecondariesToo = false;
        })
    }

    shouldShowUpdateAlreadyImported() {
        if(this.importType == 'file') return true;
        if(this.importType == 'dhm' || this.importType == 'eppoi' || this.importType == 'entourance' || this.importType == 'wordpress') {
            return !this.isCheckingImported && (this.isCheckIncomplete() || this.getCheckImportedCount() > 0);
        }
        return false;
    }

    isCheckIncomplete() {
        return this.checkResult?.incomplete === true;
    }

    getCheckImportedCount() {
        return this.checkResult?.imported?.length || 0;
    }

    editJobRefresh() {
        this.editJob.type = this.importType;
        this.editJob.realm = this.authService.user.realm.id;        

        if(this.editJob.type == 'entourance') {
            this.editJob.APIUrl = this.APIUrl;
            this.editJob.items = []

            if(this.resourceId != null) {
                if(this.elementList == null || this.elementList.length == 0) {
                    this.editJob.items.push({
                        id: null,
                        resource: this.resourceId
                    })
                }
                else {
                    for(let _element of this.elementList) {
                        this.editJob.items.push({
                            id: _element,
                            resource: this.resourceId
                        })
                    }
                }
            }
        }
        else if(this.editJob.type == 'file') {
            this.editJob.file = this.importFile?.name;
            this.editJob.fileToSend = this.importFile;

            if(this.isImportFileXLSX()) {
                this.editJob.resource = 'Host,Eatery,ExperienceSupplier'
            }
            else {
                this.editJob.resource = this.resourceId;
            }
        }
        else if(this.editJob.type == 'wordpress') {
            this.APIUrl = this.authService.user.realm.configuration.importWordPress;
            this.resourceId = 'Experience~Event';

            this.editJob.APIUrl = this.APIUrl;
            this.editJob.items = []

            if(this.elementList != null) {
                for(let _element of this.elementList) {
                    this.editJob.items.push({
                        id: _element,
                        resource: this.resourceId
                    })
                }
            }
        }
        else if(this.editJob.type == 'dhm') {
            this.editJob.items = []

            if(this.resourceElementList != null) {
                for(let _element of this.resourceElementList) {
                    this.editJob.items.push({
                        id: _element.id,
                        resource: _element.resource
                    })
                }
            }
        }
        else if(this.editJob.type == 'eppoi') {
            this.editJob.items = []

            if(this.resourceElementList != null) {
                for(let _element of this.resourceElementList) {
                    let _item:WSImport.JobEPPOIItem = {
                        id: _element.id,
                        resource: _element.resource
                    }
                    if(_element.municipality != null) _item.municipality = _element.municipality
                    if(_element.page != null) _item.page = _element.page
                    this.editJob.items.push(_item)
                }
            }
        }
    }

    onAPIUrlChange() {
        //this.resourceId = null;
        this.elementList = []
        
        this.editJobRefresh();
        this._scheduleCheckImported();
    }

    onResourceIdChange() {
        this.elementList = []
        this.editJobRefresh();
        this._scheduleCheckImported();
    }

    @ViewChild('scrollContainer') scrollContainer:ElementRef

    private _scrollToTop() {
        if(this.scrollContainer != null) {
            let _element = this.scrollContainer.nativeElement as HTMLElement

            _element.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    isImporting = false;

    updateAlreadyImported = false;
    updateSecondariesToo = false;

    hasUpdateSecondariesToo() {
        if(!this.shouldShowUpdateAlreadyImported()) return false;

        if(this.importType == 'eppoi') return false;

        if(this.importType == 'dhm') {
            for(let _element of this.resourceElementList) {
                if(_element.resource == 'Itinerary') return true;
            }
        }
    }

    async doImport() {
        if(this.importType == 'entourance' || this.importType == 'wordpress' || this.importType == 'dhm' || this.importType == 'eppoi') {
            let _items:Array<WSImport.JobEntouranceItem|WSImport.JobEPPOIItem> = []

            if(this.importType == 'dhm') {
                for(let _element of this.resourceElementList) {
                    _items.push({
                        resource: _element.resource,
                        id: _element.id
                    })
                }
            }
            else if(this.importType == 'eppoi') {
                for(let _element of this.resourceElementList) {
                    let _item:WSImport.JobEPPOIItem = {
                        resource: _element.resource,
                        id: _element.id
                    }
                    if(_element.municipality != null) _item.municipality = _element.municipality
                    if(_element.page != null) _item.page = _element.page
                    _items.push(_item)
                }
            }
            else {
                for(let _element of this.elementList) {
                    _items.push({
                        resource: this.resourceId,
                        id: _element
                    })
                }
            }

            if(_items.length > 0) {
                this.isImporting = true;

                let _observable:Observable<void> = null;
    
                if(this.importType == 'entourance') {
                    _observable = this.importerService.importEntourance(this.APIUrl, _items, this.authService.user.realm?.id, this.updateAlreadyImported)
                }
                else if(this.importType == 'wordpress') {
                    _observable = this.importerService.importWordPress(this.APIUrl, _items, this.authService.user.realm?.id, this.updateAlreadyImported)
                }
                else if(this.importType == 'dhm') {
                    let _force = null;

                    if(this.updateAlreadyImported) {
                        _force = 'update'
                        if(this.updateSecondariesToo) _force = 'update-secondaries'
                    }

                    _observable = this.importerService.importDHM(_items, this.authService.user.realm?.id, _force)
                }
                else if(this.importType == 'eppoi') {
                    let _force = null;

                    if(this.updateAlreadyImported) {
                        _force = 'update'
                    }

                    _observable = this.importerService.importEPPOI(_items as Array<WSImport.JobEPPOIItem>, this.authService.user.realm?.id, _force)
                }
                
                _observable.subscribe(() => {
                    this.setImportType(this.importType)
                    this.isImporting = false;
                }, () => {
                    this.isImporting = false;
                })
            }
        }
        else if(this.importType == 'file') {
            let _resources = null;

            if(this.isImportFileXLSX()) {
                _resources = 'Host,Eatery,ExperienceSupplier';
            }
            else _resources = this.resourceId

            this.isImporting = true;

            this.importerService.importFile(this.importFile.name, this.importFile, _resources, this.authService.user.realm?.id, this.updateAlreadyImported ? 'update' : null).subscribe(() => {
                this.isImporting = false;
                this.setImportType('file')
            }, () => {
                this.isImporting = false;
            })
        }

        this._scrollToTop()
    }

    isJobInProgress(job:WSImport.Job) {
        if(job.progress.length < job.items.length) return true;
        else {
            for(let _item of job.progress) {
                if(_item.time_end == null) {
                    return true;
                }
            }
        }

        return false;
    }

    hasJobUpdate(job:WSImport.Job, secondaries?:boolean) {
        if(job.type == 'entourance' || job.type == 'wordpress' || job.type == 'file' || job.type == 'dhm' || job.type == 'eppoi') {
            for(let i = 0; i < job.progress.length; i++) {
                let _progress = job.progress[i]
                if(!_progress.secondary && _progress.status == 'update') {
                    if(secondaries) {
                        return (job.type == 'dhm' && job.items[i].resource == 'Itinerary');
                    }
                    else return true;
                }
            }
        }

        return false;
    }

    jobUpdate(job:WSImport.Job, secondaries?:boolean) {
        if(job.type == 'entourance' || job.type == 'wordpress' || job.type == 'dhm' || job.type == 'eppoi') {
            let _items:Array<WSImport.JobEntouranceItem|WSImport.JobWordPressItem> = []

            for(let i = 0; i < job.progress.length; i++) {
                if(!job.progress[i].secondary && job.progress[i].status == 'update') _items.push({
                    resource: job.items[i].resource,
                    id: job.items[i].id
                })
            }

            if(job.type == 'entourance') {
                this.importerService.importEntourance(job.APIUrl, _items, job.realm, true).subscribe(() => {}, () => {})
            }
            else if(job.type == 'wordpress') {
                this.importerService.importWordPress(job.APIUrl, _items, job.realm, true).subscribe(() => {}, () => {})
            }
            else if(job.type == 'dhm') {
                let _force:'update'|'update-secondaries' = 'update';
                if(secondaries) _force = 'update-secondaries'

                this.importerService.importDHM(_items, job.realm, _force).subscribe(() => {}, () => {})
            }
            else if(job.type == 'eppoi') {
                let _eppoiItems:Array<WSImport.JobEPPOIItem> = []

                for(let i = 0; i < job.progress.length; i++) {
                    if(!job.progress[i].secondary && job.progress[i].status == 'update') {
                        let _jobItem = job.items[i] as WSImport.JobEPPOIItem
                        let _item:WSImport.JobEPPOIItem = {
                            resource: _jobItem.resource,
                            id: _jobItem.id
                        }
                        if(_jobItem.municipality != null) _item.municipality = _jobItem.municipality
                        if(_jobItem.page != null) _item.page = _jobItem.page
                        _eppoiItems.push(_item)
                    }
                }

                this.importerService.importEPPOI(_eppoiItems, job.realm, 'update').subscribe(() => {}, () => {})
            }
        }
        else if(job.type == 'file') {
            let _items:Array<WSImport.JobFileItem> = []

            for(let i = 0; i < job.progress.length; i++) {
                if(job.progress[i].status == 'update') _items.push({
                    resource: job.items[i].resource,
                    id: null,
                    src: job.items[i].src,
                    type: job.items[i].type,
                    data: job.items[i].data
                })
            }

            this.importerService.importFile(job.file, _items, 'Host,Eatery,ExperienceSupplier', job.realm, "update").subscribe(() => {}, () => {})
        }

        this._scrollToTop()
    }

    hasJobInsert(job:WSImport.Job) {
        if(job.type == 'file') {
            for(let _item of job.progress) {
                if(_item.status == 'update') return true;
            }
        }

        return false;
    }

    jobInsert(job:WSImport.Job) {
        if(job.type == 'file') {
            let _items:Array<WSImport.JobFileItem> = []

            for(let i = 0; i < job.progress.length; i++) {
                if(!job.progress[i].secondary && job.progress[i].status == 'update') _items.push({
                    resource: job.items[i].resource,
                    id: job.items[i].id,
                    src: job.items[i].src,
                    type: job.items[i].type,
                    data: job.items[i].data
                })
            }

            this.importerService.importFile(job.file, _items, 'Host,Eatery,ExperienceSupplier', job.realm, "insert").subscribe(() => {}, () => {})
        }

        this._scrollToTop()
    }

    hasImportType(type) {
        if(type == 'entourance') return this.APIUrlOptions != null && this.APIUrlOptions.length > 0;
        if(type == 'wordpress') return this.authService.user.realm.configuration.importWordPress != null;
        return true;
    }

    getImportTypeIcon(type) {
        switch(type) {
            case 'entourance': return 'fa-regular fa-server';
            case 'file': return 'fa-regular fa-file-spreadsheet';
            case 'wordpress': return 'fa-brands fa-wordpress';
            case 'dhm': return 'fa-regular fa-gears';
            case 'eppoi': return 'fa-regular fa-map-location-dot';
        }
    }

    importFile:File = null;

    onSetFiles(files:Array<File>) {
        this.importFile = files[0]
        this.editJobRefresh()
    }

    isImportFileXLSX() {
        return this.importFile != null && /\.xlsx$/i.test(this.importFile.name)
    }
    
    isImportFileCSV() {
        return this.importFile != null && /\.csv$/i.test(this.importFile.name)
    }

    isImportDisabled() {
        if(this.isImporting || this.isCheckingImported) return true;
        else {
            if(this.importType == 'entourance') {
                return this.elementList.length == 0
            }
            else if(this.importType == 'file') {
                return this.importFile == null || (this.isImportFileCSV() && this.resourceId == null)
            }
            else if(this.importType == 'wordpress') {
                return this.elementList.length == 0
            }
            else if(this.importType == 'dhm' || this.importType == 'eppoi') {
                return this.resourceElementList.length == 0
            }
            else return true;
        }
    }

    getImportTemplateUrl(type:string) {
        return this.importerService.getImportTemplateUrl(type)
    }

    jobCancel(job:WSImport.Job) {
        this.importerService.cancelJob(job.time).subscribe(() => {}, () => {})
    }
}
